<template>
  <div>
    <!-- <div class="header-search">
      <van-search v-model="value1" @search="onSearch" placeholder="请输入产品名称">
        <template #left-icon>
          <svg-icon @click.prevent="onSearch" icon-class="home_search"></svg-icon>
        </template>
      </van-search>
      <div class="header-search-img">
        <svg-icon icon-class="home_info"></svg-icon>
      </div>
    </div> -->
    <!-- <div class="product-swipe">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in swipeImg1" :key="index">
          <img :src="item.img" alt />
        </van-swipe-item>
      </van-swipe>
    </div> -->
    <div class="pro-but">
      <van-button color="#fc6e09" @click="checkProducts">提交选中产品</van-button>
    </div>
     <van-checkbox class="topCheckbox" shape="square" checked-color="#fc6e09" v-model="isAllProduct" @click="checkAllPro()">选中全部产品</van-checkbox>
    <div class="product-list">
      <ul class="product-nav">
        <li
          v-for="(item,index) in liList"
          :key="index"
          :class="isLink==item.id ? 'li-style li-check-style' : 'li-style'"
          @click="chooseLi(item,index)"
        >
          {{item.name}}
          <svg-icon v-if="isLink==item.id" icon-class="home_line2"></svg-icon>
        </li>
      </ul>
      <div class="content-div">
        <div
          class="pro-list-list"
          v-for="(item,index) in newDataList"
          :id="'nav_'+item.id"
          :key="index"
        >
          <div class="product-type-title"> <van-checkbox checked-color="#fc6e09" v-model="item.allResult" @click="checkAll(item)">{{item.name}}</van-checkbox></div>
          <div v-if="item.name=='银行'">
            <van-checkbox-group v-model="item.result">
              <van-checkbox
                :name="c.id"
                v-for="(c,i) in item.value"
                :key="i"
                checked-color="#fc6e09"
                @click.prevent="checkData(item)"
              >
                <div class="bank-list">
                  <div class="list-com bank-top">
                    <div class="bank-top-left">
                      <div class="bank-top-left-img">
                        <img :src="c.thumbnail" alt />
                      </div>
                      <div>
                        <p class="product-list-title">{{c.name}}</p>
                        <p class="product-list-summary">手续简单抵押率高</p>
                      </div>
                    </div>
                  </div>
                  <div class="list-com bank-bottom">
                    <p v-html="c.digest"></p>
                  </div>
                </div>
              </van-checkbox>
            </van-checkbox-group>
          </div>
          <div v-else>
            <van-checkbox-group v-model="item.result">
              <van-checkbox
                :name="t.id"
                v-for="(t,i) in item.value"
                :key="i"
                checked-color="#fc6e09"
                @click.prevent="checkData(item)"
              >
               <div
              class="bank-list product-safe"
            >
              <div class="product-safe-left">
                <img :src="t.thumbnail" alt />
              </div>
              <div class="product-safe-right">
                <div>
                  <p class="product-list-title">{{t.name}}</p>
                  <div class="safe-right-height">
                    <p v-html="t.digest" class="product-list-summary"></p>
                  </div>
                </div>
              </div>
            </div>
              </van-checkbox>
            </van-checkbox-group>
           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/api/api'
import { Toast, Dialog } from 'vant'
import { setLocal } from "@/utils/utils";
export default {
  data() {
    return {
      value1: '',
      isLink: null,
      active: '全部',
      productList: [],
      newDataList: [],
      productListShow: [],
      value: this.$route.query.value,
      search: '',
      swipeImg1: [
        { img: require('./img/product_banner.png') },
      ],
      liList: [],
      isAllProduct:false,//全部选中
      page: 1,//当前页数
      size: 12,//每页数量
      total: 0,
    }
  },
  mounted() {
    // this.fatchdata()
    this.getProductType()
    // this.getData()
    this.$nextTick(() => {
      this.addListener()
    })
  },

  methods: {
    checkAllPro(){//选中全部产品
      if(this.isAllProduct){
        this.newDataList.map(x=>{
          x.result=x.value.map(y=>{return y.id})
          x.allResult=true
        })
      }else{
        this.newDataList.map(x=>{
          x.result=[]
          x.allResult=false

        })
      }
    },
    handleList(){//处理产品产品数据
      this.isAllProduct=true
      this.newDataList.map(x=>{
        if(x.result.length!=x.value.length){
          this.isAllProduct=false
        }
      })
    },
    checkAll(v){//类别全选
      console.log(v);
      if(v.allResult){
        v.value.map(x=>{
          v.result.push(x.id)
        })
      }else{
        v.result=[]
      }
      this.handleList()
    },
    checkProducts(){//保存选择数据
      let result=[]
      this.newDataList.map(x=>{
        if(x.result.length>0){
          result.push(x.result.toString())
        }
      })
      let data={
        phoneNo:localStorage.getItem('phone'),
        recommendInfo:result.toString()
      }
      this.$fetchPost(URL.productSave.url,data).then(res=>{
        if(res.data.code==20000){
          this.$router.replace('/homePageB')
        }
      })
    },
    addListener() {//
      let targetName = document.getElementsByClassName('content-div')[0]
      targetName.addEventListener("scroll", (e) => {
        this.handleScroll(e)
      });
    },
    handleScroll(event) {
      console.log(event);
      //最外层距离顶部距离
      let bigTop = document.getElementsByClassName('content-div')[0].offsetTop
      //当前滚动条离顶部距离
      let bigTop1 = document.getElementsByClassName('content-div')[0].scrollTop + bigTop
      this.liList.map(x => {
        let idFind = 'nav_' + x.id
        //点击导航里面的id选择器距离顶部距离
        let smallTop = document.getElementById(idFind).offsetTop
        let smallTopHeight = document.getElementById(idFind).scrollHeight
        //当前id选择器距离顶部位置
        let smallTop1 = smallTop - bigTop - 15
        console.log(bigTop1, smallTop1, 'jjjj');
        if (bigTop1 >= smallTop1 && bigTop1 < smallTop1 + smallTopHeight) {
          this.isLink = x.id
        }
      })
    },
    getProductType() {
      this.$fetchGet(URL.findplist.url, { flag: 0, createCompany: 'ZFKJ' }).then(res => {

        if (res.data && res.data.length > 0) {
          res.data.shift();
          let data1 = res.data;
          (data1 || []).map(res => {
            res.id = res.value[0].idProductType
            res.result = []
            res.allResult = false
          })
          this.newDataList = data1
          this.liList = data1
          if (!this.isLink) {
            this.isLink = this.liList[0].id
          }
        }
      })
    },
    delRemoval(arr2) {
      var temp = [];
      arr2.forEach(function (a) {
        var check = temp.every(function (b) {
          return a.name !== b.name;
        })
        check ? temp.push(a) : ''
      })
      return temp;
    },
    chooseLi(item, i) {
      this.isLink = item.id
      let idFind = 'nav_' + item.id
      //最外层距离顶部距离
      let bigTop = document.getElementsByClassName('content-div')[0].offsetTop
      //点击导航里面的id选择器距离顶部距离
      let smallIop = document.getElementById(idFind).offsetTop
      document.getElementsByClassName('content-div')[0].scrollTop = smallIop - bigTop - 15
    },
    checkData(item) {
      console.log(item);
      item.allResult=true
      if(item.result.length<item.value.length){
        item.allResult=false
      }
      this.handleList()
    },
    fatchdata() {
      this.$fetchGet(URL.findplist.url, { flag: 0, createCompany: 'ZFKJ' }).then(res => {
        this.productList = res.data;
        if (res.data && res.data.length > 0) {
          if (this.isLink == null) {
            this.isLink = 0
          }
          this.chooseLi(this.productList[this.isLink], this.isLink)
        }
      })
    },
    // onSearch() {
    //   let that = this
    //   that.page = 1
    //   that.getData()
    // },
  }
}
</script>

<style lang="less" scoped>
.header-search {
  width: 355px;
  height: 26.5px;
  // margin: auto;
  display: flex;
  justify-content: space-around;
  // .svg-icon {
  //   width: 21.73px;
  //   height: 20.5px;
  // }
  // .header-search-img {
  //   margin-left: 10px;
  //   line-height: 26.5px;
  // }
  .van-search {
    width: 323.5px;
    padding: 0;
    border-radius: 5px;
    .van-search__content {
      padding: 0;
      line-height: 26.5px;
    }
    .van-cell {
      padding: 0;
      border: 0.5px solid #ff6c00;
      border-radius: 5px;
    }
    .svg-icon {
      width: 14.24px;
      height: 14.24px;
      padding-left: 5px;
    }
  }
}
.pro-but{
  padding: 10px 0 0 10px;
}
.topCheckbox{
  padding: 15px 10px;
  font-size: 16px;
  font-weight: bold;
}
.product-swipe {
  width: 355px;
  margin: 11px auto 0 auto;
  // .svg-icon {
  //   width: 355px;
  //   height: 80px;
  // }
  img {
    width: 355px;
    height: 80px;
  }
}
.product-list {
  width: 375px;
  // margin-bottom: 32.5px;
  p {
    font-family: PingFang SC;
    color: #333333;
  }
  .product-list-title {
    width: 115px;
    height: 20px;
    overflow: hidden;
    margin: 12px 0 8px 18px;
    font-size: 14px;
    font-weight: Bold;
  }
  .product-list-summary {
    width: 115px;
    height: 14.5px;
    margin-left: 18px;
    font-size: 10.5px;
    font-weight: Regular;
    overflow: hidden;
  }
  .product-common-title {
    margin-top: 22px;
  }
  .product-nav {
    width: 375px;
    height: 48.5px;
    align-items: center;
    display: flex;
    justify-content: space-around;
    margin-top: 12.5px;
    background: url("./img/product_bg.png") no-repeat 100%;
    background-size: 100%;
    .svg-icon {
      width: 13.5px;
      height: 2px;
      display: block;
      //   margin-left: 5.5px;
      //   margin-top: 2.5px;
      margin: 2.5px auto 0 auto;
    }
    .li-style {
      //   width: 28.5px;
      font-size: 14px;
      font-family: PingFang SC;
      color: #333333;
      font-weight: lighter;
    }
    .li-check-style {
      font-weight: Regular;
      color: #fc6e09;
    }
  }
  .content-div {
    max-height: calc(100vh - 165px);
    overflow: scroll;
  }
  .pro-list-list {
    width: 355px;
    margin: 15.5px auto 0 auto;
    .product-type-title {
      margin-left: 10px;
      font-size: 16px;
      font-weight: Bold;
      color: #333333;
    }
    .bank-list {
      width: 315px;
      //   height: 153.5px;
      margin-top: 15.5px;
      padding: 10.5px 0 9.5px 0;
      background: #ffffff;
      border-radius: 10px;
      &:last-child{
        margin-bottom: 15px;
      }
      //   background: url('./img/product_bg1.png') no-repeat 100%;
      //   background-size: 100% 100% ;
      .list-com {
        width: 335px;
        margin: auto;
      }
      .bank-top,
      .bank-top-left {
        height: 65px;
        display: flex;
        .bank-top-left-img {
          width: 128px;
          height: 65px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .bank-top {
        // justify-content: space-between;
        // align-items: center;
        padding-left: 10px;
      }
      .bank-bottom {
        height: 56.5px;
        margin-top: 12px;
        line-height: 1.5;
        overflow: hidden;
        p {
          height: 14px;
          padding-left: 17.5px;
          font-size: 10px;
        }
      }
    }
    .product-safe {
      height: 135px;
      padding: 0;
      align-items: center;
      display: flex;
      .product-safe-left {
        width: 128px;
        height: 110px;
        margin-left: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .product-safe-right {
        // border: 1px solid;
        width: 155px;
        height: 110px;
        margin-left: 11.5px;
        position: relative;
        .safe-right-but {
          position: absolute;
          bottom: 0;
          right: 0;
        }
        .safe-right-height {
          height: 48px;
          overflow: hidden;
        }
        .product-list-summary {
          width: auto;
          height: auto;
          margin-top: 2px;
          margin-left: 0;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .product-list-title {
          width: auto;
          margin: 0;
          overflow: inherit;
          display: inline-block;
        }
      }
    }
  }
}
</style>